// Redux Action Types
import {
  SET_SELECTED_DATE, DECREMENT_SEVEN_DAYS, INCREMENT_SEVEN_DEYS, SET_SELECTED_SEVEN_DAYS, INCREMENT_MONTH, DECREMENT_MONTH
} from './types';

export const setSelectedDate = payload => ({
  type: SET_SELECTED_DATE,
  payload
});

export const incrementSevenDays = payload => ({
  type: INCREMENT_SEVEN_DEYS,
  payload
});

export const decrementSevenDays = payload => ({
  type: DECREMENT_SEVEN_DAYS,
  payload
});


export const incrementMonth = payload => ({
  type: INCREMENT_MONTH,
  payload
});

export const decrementMonth = payload => ({
  type: DECREMENT_MONTH,
  payload
});